import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'handleAdjustOrderInProgress',
  initialState: false,
  reducers: {
    setHandleAdjustOrderInProgress(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHandleAdjustOrderInProgress } = slice.actions;

export default slice.reducer;
